/**
 * A collection card for one model of a multi-model product (see snippets/model-card.liquid).
 *
 * Every colour's gallery is rendered server-side; choosing a colour shows that colour's gallery and points the
 * card's links and price at the matching variant. No network request is needed.
 */
class ModelCard extends HTMLElement {
  connectedCallback() {
    this.addEventListener('change', this.#handleChange);
  }

  disconnectedCallback() {
    this.removeEventListener('change', this.#handleChange);
  }

  /**
   * @param {Event} event
   */
  #handleChange = (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || input.type !== 'radio') return;

    const { variantId, variantUrl, price } = input.dataset;
    if (!variantId) return;

    for (const set of this.querySelectorAll('.model-card__gallery-set')) {
      if (set instanceof HTMLElement) set.hidden = set.dataset.variantId !== variantId;
    }

    if (variantUrl) {
      for (const link of this.querySelectorAll('.model-card__details [data-model-card-link]')) {
        if (link instanceof HTMLAnchorElement) link.href = variantUrl;
      }
    }

    const priceElement = this.querySelector('[data-model-card-price]');
    if (priceElement && price) priceElement.textContent = price;
  };
}

if (!customElements.get('model-card')) {
  customElements.define('model-card', ModelCard);
}
